/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequestUserAccountAllInner
 */
export interface UpdateRoleResourceForUserRequestUserAccountAllInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountAllInner
     */
    'role': UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum;
}

export const UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum = typeof UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum[keyof typeof UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum];


